const weatherApiUrl = "https://api.openweathermap.org/data/2.5/";

const weatherApiToket = "4ebfdc10adb176917ee6cd4b2ab8be1f";

export const getWeatherUrls = function(city) {
  if (!city) return null;
  return ["forecast", "weather"].map(e => {
    return `${weatherApiUrl +
      e}?q=${city}&units=metric&APPID=${weatherApiToket}`;
  });
};

export const getWeatherIconName = function(id, time) {
  let iconName;

  if (id === 800) {
    if (time > 5 && time < 20) {
      iconName = "clear-sky-d";
    } else {
      iconName = "clear-sky-n";
    }
  } else if (id >= 200 && id <= 232) {
    iconName = "thunderstorm";
  } else if (id === 801) {
    if (time > 5 && time < 20) {
      iconName = "clouds-few-d";
    } else {
      iconName = "clouds-few-n";
    }
  } else if (id === 802) {
    iconName = "clouds";
  } else if (id === 803 || id === 804) {
    iconName = "clouds";
  } else if (id >= 300 && id <= 321) {
    iconName = "rain-shower";
  } else if (id >= 500 && id <= 531) {
    if (time > 5 && time < 20) {
      iconName = "rain-d";
    } else {
      iconName = "rain-n";
    }
  } else if (id >= 600 && id <= 622) {
    iconName = "snow";
  } else if (id >= 700 && id <= 781) {
    iconName = "mist";
  } else {
    if (time > 5 && time < 20) {
      iconName = "clouds-few-d";
    } else {
      iconName = "clouds-few-n";
    }
  }

  return iconName;
};
